import "./App.css";
import Main from "./Component/Main";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Privacy from "./Component/Privacy";
import ProductDetail from "./Component/ProductDetail";
import CartPage from "./Component/CartPage";
import CheckOut from "./Component/CheckOut";
import { CartProvider } from "./Component/CartContext";
import PaySuccess from "./Component/SuccessPay";
import Terms from "./Component/Terms";
import Shop from "./Component/Shop";
import Contact from "./Component/Contact";
import Returns from "./Component/Returns";
import About from "./Component/About";
import Header from "./Component/Header";
import Footer from "./Component/Footer";
import Delivery from "./Component/Delivery";
import Faqs from "./Component/Faqs";
import CookiePolicy from "./Component/CookiePolicy";
import PolicyCenter from "./Component/PolicyCenter";
import {
  AcceptableUsePolicy,
  AccessibilityPolicy,
  ComplaintsPolicy,
  GuaranteePolicy,
  InternationalPolicy,
  LegalNotice,
  OrdersPolicy,
  PaymentsPolicy,
  PricingPolicy,
  PrivacyChoices,
  ProductSafetyPolicy,
  RecallPolicy,
  SecurityPolicy,
} from "./Component/AdditionalPolicies";

function App() {
  return (
    <CartProvider>
      <Router>
        <Header />
        <Routes>
          <Route path="/about" element={<About />} />
          <Route path="/shipping" element={<Delivery />} />
          <Route path="/" element={<Main />} />
          <Route path="/returns" element={<Returns />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/shop" element={<Shop />} />
          <Route path="/terms" element={<Terms />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/faqs" element={<Faqs />} />
          <Route path="/cookies" element={<CookiePolicy />} />
          <Route path="/policies" element={<PolicyCenter />} />
          <Route path="/orders" element={<OrdersPolicy />} />
          <Route path="/payments" element={<PaymentsPolicy />} />
          <Route path="/pricing" element={<PricingPolicy />} />
          <Route path="/international" element={<InternationalPolicy />} />
          <Route path="/privacy-choices" element={<PrivacyChoices />} />
          <Route path="/security" element={<SecurityPolicy />} />
          <Route path="/accessibility" element={<AccessibilityPolicy />} />
          <Route path="/product-safety" element={<ProductSafetyPolicy />} />
          <Route path="/recalls" element={<RecallPolicy />} />
          <Route path="/guarantee" element={<GuaranteePolicy />} />
          <Route path="/acceptable-use" element={<AcceptableUsePolicy />} />
          <Route path="/legal" element={<LegalNotice />} />
          <Route path="/complaints" element={<ComplaintsPolicy />} />
          <Route path="/shopDetails/:id" element={<ProductDetail />} />
          <Route path="/cartpage" element={<CartPage />} />
          <Route path="/checkout" element={<CheckOut />} />
          <Route path="/paysuccess" element={<PaySuccess />} />
          <Route path="/payment" element={<PaySuccess />} />
        </Routes>
        <Footer />
      </Router>
    </CartProvider>
  );
}

export default App;
